import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { RequestDto } from './dto/RequestDto';

export type { RequestDto } from './dto/RequestDto';
export type { ResponseDto } from './dto/ResponseDto';

/**
 * Создает заявки БП подключения Интернет (с ПП Переключение на 100+,
 * Переключение на wi-fi и Доставка оборудования Интернет) и Дом.ru TV
 * (с пп мини-IP и Доставка оборудования ТВ)
 * https://master.api-profile.sandbox.d2c.r-one.io/docs/v2#/Tariffs/86ca9fd3cd20b78f113529cce4b27717
 * */
export const createRequest = (body: RequestDto): IRequest => ({
    uri: '/v2/change-tariff/create-request',
    method: 'POST',
    withAuth: true,
    withProvider: true,
    body: JSON.stringify(body),
});
